import type {
  GraphEdgeSettings,
  GroupEdgeSettings,
  PathLookupEdgeSettings,
  ProtocolEdgeType,
  TopologyEdgeSettings,
  TopologyGraphPreset,
} from '@ipfabric/utils';
import {
  type EnabledProtocolLabels,
  getProtocolLabels,
} from 'components/Graph/helpers/getProtocolLabels';
import { getSettingsEntity } from './getSettingsEntity';

const isProtocol = (
  settingsEntity: GraphEdgeSettings,
): settingsEntity is TopologyEdgeSettings | PathLookupEdgeSettings =>
  settingsEntity.type === 'protocol' ||
  settingsEntity.type === 'pathLookupEdge';

export const getLabels = (
  preset: TopologyGraphPreset,
  groupId: GroupEdgeSettings['id'] | null,
  protocolName?: ProtocolEdgeType,
): EnabledProtocolLabels => {
  const settingsEntity = getSettingsEntity(preset, groupId, protocolName);

  if (settingsEntity && isProtocol(settingsEntity) && protocolName) {
    return getProtocolLabels(settingsEntity);
  }
  return {
    center: {},
    linecap: {},
  };
};
